export function toKebabCase(str = ""): string {
  return str && str.split(" ")
    .map((x) => x.toLowerCase())
    .join("-")
    .replace("/", "-")
    .replace("-&-", "-and-")
    .replace(".", "-")
    .replace(/,/g, ""); // Remove all commas
  // return str && str
  //   .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
  //   .map((x) => x.toLowerCase())
  //   .join("-");
}
